export const PaginationBlank = () => {
  return {
    current_page: 1,
    per_page: 24,
    total: 0,
  };
}
